import template from './users.all.html';
import controller from './users.all.controller';
import './users.all.scss';

let usersallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default usersallComponent;


// WEBPACK FOOTER //
// ./client/app/components/users/all/users.all.component.js